import React, { useState, useEffect, use } from "react";
import { useNavigate } from 'react-router-dom';

function ProductPage() {
  const urlParams = new URLSearchParams(window.location.search);
  const imageUrl = urlParams.get('imageUrl');
  const allImages = JSON.parse(urlParams.get('allImages') || '[]');
  const [itemsInCart, setItemsInCart] = useState([]);
    const product = JSON.parse(urlParams.get('productInfo') || '[]');
    const [similarProductsInformation, setSimilarProductsInformation] = useState([]);
    const [similarProductImages, setSimilarProductImages] = useState({});
    const navigate = useNavigate();
    const [pidFromURL, setPidFromURL] = useState(null);

    function fetchSimilarProductsInformation(category) {
        fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/similarProducts?category=${encodeURIComponent(category)}`)
          .then(res => res.json())
          .then(data => {
            setSimilarProductsInformation(data);
            fetchSimilarProductImages(data);
          })
          .catch(err => console.error(err));
      }

      function fetchSimilarProductImages(products) {
        console.log("Fetching images for similar products:", products);
        const imagesMap = {};
        const fetches = products.map(product =>
          fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/product-images/${product.pid}`)
            .then(res => res.json())
            .then(imageUrls => {
              imagesMap[product.pid] = imageUrls;
            })
            .catch(err => {
              console.error(`Error fetching images for product ${product.pid}:`, err);
              imagesMap[product.pid] = [];
            })
        );
    
        Promise.all(fetches)
          .then(() => setSimilarProductImages(imagesMap))
          .catch(err => console.error('Error fetching similar product images:', err));
      }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


  function lookAtCart(parsedCartData){
      let cartItems = []
      for (let i = 0; i < parsedCartData.length; i++){
        cartItems.push(parsedCartData[i].productInfo.pid)
      }
      setItemsInCart(cartItems)
      fetchSimilarProductsInformation(product.category);
      setPidFromURL(product.pid)

  }

    useEffect(() =>{
        const userCartFromStorage = localStorage.getItem("userCart");
        if(userCartFromStorage){
            const parsedCartData = JSON.parse(userCartFromStorage);
            lookAtCart(parsedCartData)
        }
        else{
            fetchSimilarProductsInformation(product.category);
            setPidFromURL(product.pid)
        }
    }, []);
  


  const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  
    function useWindowSize() {
        useEffect(() => {
        function handleResize() {
            setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
            });
        }
        
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return windowSize;
  }
  
  function horizontalSpacer(width) {
    return <div style={{ display: "inline-block", width: width }}></div>;
  }
  
  function verticalSpacer(height) {
    return <div style={{ height: height }}></div>;
  }

  function handleProductClick(product){
    // const queryString = new URLSearchParams(product).toString();
    // window.location.href = `/product?${queryString}`;
    const productWithImages = {
      ...product,
      // Pass first image or all images as JSON
      imageUrl: similarProductImages[product.pid] && similarProductImages[product.pid].length > 0 
        ? similarProductImages[product.pid][0] 
        : '',
      // Optional: pass all images as JSON string
      allImages: similarProductImages[product.pid] 
        ? JSON.stringify(similarProductImages[product.pid]) 
        : '[]',
      productInfo: product 
        ? JSON.stringify(product) 
        : '[]'
    };
  
    const queryString = new URLSearchParams(productWithImages).toString();
    //console.log(queryString)
    //window.location.replace(`/product?${queryString}`);
    //navigate(`/product?${queryString}`);
    // console.log(window.history.replaceState({}, document.title, window.location.pathname));
    // console.log(window.location.href);
    // console.log("herrre")
    window.history.replaceState({}, document.title, `/product?${queryString}`);
    // console.log(window.location.href);
    setPidFromURL(product.pid)
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
    setCurrentImageIndex(0);
  }
  
  
//   const product = {
//     pid: urlParams.get('pid'),
//     pname: urlParams.get('pname'),
//     price: urlParams.get('price'),
//     size: urlParams.get('size'),
//     category: urlParams.get('category'),
//     stock: urlParams.get('available'),
//   };
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Use all images if available, otherwise use single imageUrl
  const images = allImages.length > 0 ? allImages : (imageUrl ? [imageUrl] : []);
  
  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? images.length - 1 : prev - 1
    );
  };
  
  const handleNextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === images.length - 1 ? 0 : prev + 1
    );
  };
  
  return (
    <div>
    <div className="product-page-container" style={{ paddingLeft: 10, paddingRight: 10, display: 'flex', justifyContent: 'center'}}>
      <div style={{
        background: "#89807c",
        border: "1px solid #a09692",
        borderRadius: 25,
        maxWidth: 600,
        width: '100%',
        paddingTop: 5,
        paddingLeft: 5,
        paddingRight: 5,
        paddingBottom: 20,
        boxShadow: "0px 5px 5px #4b4745",
        marginTop: 20
      }}>
        {/* Image Carousel - TOP */}
        <div style={{ marginBottom: 20 }}>
          {images.length > 0 ? (
            <div style={{ 
              position: 'relative', 
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {/* Left Arrow */}
              {images.length > 1 && (
                <button
                  onClick={handlePrevImage}
                  style={{
                    position: 'absolute',
                    left: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: 40,
                    height: 40,
                    fontSize: 20,
                    cursor: 'pointer',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ‹
                </button>
              )}
              
              {/* Image */}
              <img
                src={images[currentImageIndex]}
                alt={`Product ${currentImageIndex + 1}`}
                style={{
                  width: "auto",
                  height: 400,
                  maxWidth: '100%',
                  objectFit: 'cover',
                  borderRadius: 20,
                  borderTopLeftRadius: 20,
                  borderTopRightRadius: 20,
                  border: "1px solid rgb(79, 67, 54, 0.5)",
                  display: "block",
                  margin: "0 auto",
                  boxShadow: "0px 10px 20px rgba(0,0,0,0.5)"
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              
              {/* Right Arrow */}
              {images.length > 1 && (
                <button
                  onClick={handleNextImage}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: 40,
                    height: 40,
                    fontSize: 20,
                    cursor: 'pointer',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ›
                </button>
              )}
              
              {/* Image Counter */}
              {images.length > 1 && (
                <div style={{
                  position: 'absolute',
                  bottom: 10,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'rgba(0, 0, 0, 0.5)',
                  color: 'white',
                  padding: '5px 10px',
                  borderRadius: 15,
                  fontSize: 14
                }}>
                  {currentImageIndex + 1} / {images.length}
                </div>
              )}
            </div>
          ) : (
            <div style={{
              width: "auto",
              height: 400,
              backgroundColor: '#e0e0e0',
              borderRadius: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              color: '#999'
            }}>
              No Images Available
            </div>
          )}
        </div>

        {/* Product Info - BOTTOM */}
        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
          <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 10 }}>
            {product.pname || 'Product Name'}
          </h1>
          
          {product.size && (
            <p style={{ fontSize: 16, marginBottom: 10 }}>
              Size: {product.size}
            </p>
          )}
          
          {product.stock && (
            <p style={{ fontSize: 16, marginBottom: 10 }}>
              Stock: {product.stock} available
            </p>
          )}
          
          <div style={{ fontSize: 18, fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 15 }}>
            <span>${product.price ? Number(product.price).toFixed(2) : '0.00'}</span>
            
            <button
              style={{
                padding: "7px 10px",
                borderRadius: 12,
                border: "1px solid #686666",
                background: "rgb(248, 198, 149)",
                cursor: "pointer",
                color: "#000000",
                fontSize: 14
              }}
              onClick={() => {
                
                if(itemsInCart && !itemsInCart.includes(product.pid)){
                    setItemsInCart(prev => [...prev, product.pid])
                    const userCartFromStorage = localStorage.getItem("userCart");
                    
                    if(!userCartFromStorage){
                        const userCartToStorage1 = []
                        const userCartToStorage = {
                            productInfo: product,
                            productPictures: allImages,
                            count: 1
                        }
                        userCartToStorage1.push(userCartToStorage)
                        // itemsInCart.push(product.pid)
                        localStorage.setItem('userCart', JSON.stringify(userCartToStorage1));
                    }
                    else{
                        // itemsInCart.push(product.pid)
                        const parsedCartData = JSON.parse(userCartFromStorage);
                        const userCartToStorage = {
                            productInfo: product,
                            productPictures: allImages,
                            count: 1
                        }
                        
                        parsedCartData.push(userCartToStorage)
                        localStorage.setItem('userCart', JSON.stringify(parsedCartData));
                    }
                }
                else{
                    window.location.replace('/CartPage');
                }
              }}
            >
              {itemsInCart && itemsInCart.includes(product.pid) ? 
                  "View In Cart" : "add to cart"
                }
            </button>
          </div>
        </div>
      </div>
      

      
      
    </div>
    {verticalSpacer(20)}
    {similarProductsInformation?.[0]?.pid !== pidFromURL ? (
      <div>
    <div style={{
                background: "#4d4c4c",
                height: "2px",
                width: "100%"
                        
            }}>
            </div>

    <h2 style={{fontSize: 24, fontWeight: 400, textAlign: "left", marginLeft: 20 }}>Customers who viewed this item also viewed</h2>
    </div>
    ) : null}
    <div className="similarProductsContainer">
        <div className="home-page" style={{ padding: 32, display: "grid", gridTemplateColumns: "repeat(auto-fit, 260px)",  flexDirection: "row", flexWrap: "wrap", justifyContent: "center", gap: 40, }}>
      
      {similarProductsInformation.map(product => (
        product.pid !== pidFromURL ? (
        <div
          key={product.pid}
          className="homeSheetsContainer"
          style={{
            background: "#89807c", //"rgba(139, 132, 132, 0.9)",
            border: "1px solid #a09692",
            borderRadius: 25,
            width: 260,
            height: 410,
            paddingTop: 5,
            paddingLeft: 3,
            paddingRight: 6,
            paddingBottom: 10,
            cursor: 'pointer',
            boxShadow: "0px 5px 5px #4b4745"
            // boxSizing: 'border-box'
          }}
          onClick={()=>handleProductClick(product)}
        >
          {/* Display image from API */}
          {similarProductImages[product.pid] && similarProductImages[product.pid].length > 0 ? (
            <img
              style={{
                width: "auto",
                height: 270,
                objectFit: 'cover',
                borderRadius: 20,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                border: "1px solid rgb(79, 67, 54, 0.5)",
                display: "block",
                margin: "0 auto",
                boxShadow: "0px 10px 20px rgba(0,0,0,0.5)"
              }}
              src={similarProductImages[product.pid][0]} // Already a complete URL
              alt={product.pname}
              className="homeSheetImage"
              onError={(e) => {
                console.error("Image failed to load:", similarProductImages[product.pid][0]);
                e.target.style.display = 'none';
              }}
            />
          ) : (
            // No image available
            <div style={{
              width: "auto",
              height: 270,
              backgroundColor: '#e0e0e0',
              borderRadius: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 5,
              color: '#999'
            }}>
              No Image Available
            </div>
          )}

          <p style={{ fontSize: 18, fontWeight: 600 }}>
            {product.pname}
          </p>

          <p >Size: {product.size}</p>

          <div style={{ fontSize: 16, fontWeight: 500, paddingBottom: 20 }}>
            ${Number(product.price).toFixed(2)}
            {horizontalSpacer(111)}
            <button style={{
                padding: "7px 10px",
                borderRadius: 12,
                border: "1px solid #686666",
                background: "rgb(248, 198, 149)",
                cursor: "pointer",
                marginLeft: 12,
                color: "#000000ff"
              }}type="button"onClick={(e) => {
                e.stopPropagation(); //stops the event from bubbling up
                if(itemsInCart && !itemsInCart.includes(product.pid)){
                const userCartFromStorage = localStorage.getItem("userCart");
                if(!userCartFromStorage){
                  const userCartToStorage1 = []
                  const userCartToStorage = {
                    productInfo: product,
                    productPictures: similarProductImages[product.pid],
                    count: 1
                  }
                  userCartToStorage1.push(userCartToStorage)
                  console.log(userCartToStorage1)
                  lookAtCart(userCartToStorage1)
                  localStorage.setItem('userCart', JSON.stringify(userCartToStorage1));
                }
                else{
                  const parsedCartData = JSON.parse(userCartFromStorage);
                  const userCartToStorage = []
                  for (let i = 0; i < parsedCartData.length; i++){
                    userCartToStorage.push(parsedCartData[i])
                  }
                  const userCartToStorage2 = {
                    productInfo: product,
                    productPictures: similarProductImages[product.pid],
                    count: 1
                  }
                  let foundLocation = false
                  for (let i = 0; i < userCartToStorage.length; i++){
                    if(userCartToStorage[i].productInfo.pid === userCartToStorage2.productInfo.pid){
                      userCartToStorage[i].count += 1
                      foundLocation = true
                      break
                    }
                  }
                  if(!foundLocation){
                    userCartToStorage.push(userCartToStorage2)
                  }
                  lookAtCart(userCartToStorage)
                  localStorage.setItem('userCart', JSON.stringify(userCartToStorage));
                  console.log(userCartToStorage)
                }
              }
              else{
                window.location.replace('/CartPage');
              }
                
                //console.log(userDataToStore)
                // localStorage.setItem('userCart', JSON.stringify(userDataToStore));
                //window.location.href = '/CartPage';
              }}>
                {itemsInCart && itemsInCart.includes(product.pid) ? 
                  "View In Cart" : "add to cart"
                }
                
            </button>
          </div>
        </div>
      ) : null
      ))}
    </div> 

      </div>
        {verticalSpacer((windowSize.width * 0.5) + (windowSize.height * 0.8))}
    </div>
  );
}

export default ProductPage;